function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect, useState } from 'react';
import shallow from 'zustand/shallow';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { FiMap } from 'react-icons/fi';
import useStore from './../store';
import { CoreButton, TourIcon } from './../../../core';
import { GeocodeSearch } from './../GeocodeSearch';
/**
 * Layout sets up the basic layout for the explorer.
 * @param Object children Child elements
 * @param Object props    Props passed from parent
 */

var IntroModal = function IntroModal(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]); // console.log('introModal')


  var _useStore = useStore(function (state) {
    return {
      setStoreValues: state.setStoreValues,
      showIntroModal: state.showIntroModal,
      enableTour: state.enableTour
    };
  }, shallow),
      setStoreValues = _useStore.setStoreValues,
      showIntroModal = _useStore.showIntroModal,
      enableTour = _useStore.enableTour;

  var toggleIntroModal = function toggleIntroModal() {
    return setStoreValues({
      showIntroModal: !showIntroModal
    });
  };
  /**
   * Close the intro panel and start the tour
   */


  var handleStartTour = function handleStartTour() {
    // console.log('handleStartTour()')
    toggleIntroModal();
    setStoreValues({
      runTour: true
    });
  };
  /**
   * Navigate to FAQ page.
   */


  var handleGoToFAQ = function handleGoToFAQ() {
    if (!!window) {
      var href = window.location.origin + '/faq/';
      window.location.href = href;
    }
  };

  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: showIntroModal,
    toggle: toggleIntroModal,
    className: "intro-modal bs-expl",
    backdrop: true,
    keyboard: true,
    autoFocus: true,
    centered: true
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: toggleIntroModal
  }), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("div", {
    className: clsx('site-title')
  }, i18n.translate('SITE_TITLE')), /*#__PURE__*/React.createElement("div", {
    className: clsx('cpal-logo'),
    role: "image",
    "aria-label": "CPAL logo"
  }), /*#__PURE__*/React.createElement("div", {
    className: "logo"
  })), /*#__PURE__*/React.createElement("p", null, i18n.translate('UI_MAP_INTRO_MODAL_INTRO')), !!enableTour && /*#__PURE__*/React.createElement("div", {
    className: "intro-modal-option"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cta"
  }, i18n.translate('UI_MAP_INTRO_MODAL_TOUR')), /*#__PURE__*/React.createElement(CoreButton, {
    color: "light",
    label: i18n.translate('UI_MAP_INTRO_MODAL_TOUR_BTN'),
    onClick: handleStartTour
  }, /*#__PURE__*/React.createElement(TourIcon, null), i18n.translate('UI_MAP_INTRO_MODAL_TOUR_BTN'))), /*#__PURE__*/React.createElement("div", {
    className: "intro-modal-option"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cta"
  }, i18n.translate('UI_MAP_INTRO_MODAL_SEARCH')), /*#__PURE__*/React.createElement(GeocodeSearch, null)), /*#__PURE__*/React.createElement("div", {
    className: "intro-modal-option"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cta"
  }, i18n.translate('UI_MAP_INTRO_MODAL_MAP')), /*#__PURE__*/React.createElement(CoreButton, {
    color: "light",
    label: i18n.translate('UI_MAP_INTRO_MODAL_MAP_BTN'),
    onClick: toggleIntroModal
  }, /*#__PURE__*/React.createElement(FiMap, null), i18n.translate('UI_MAP_INTRO_MODAL_MAP_BTN')))));
};

export default IntroModal;